import Stocks from "../components/Stocks"
const StocksPage = () =>
{
    return (
        <>
        <Stocks/>
        </>
    )
}

export default StocksPage;